import React from 'react';
import { PropTypes } from 'prop-types';

const OverrideReasonDropdown = ({
  options,
  rejection,
  onOverrideReasonChange,
  canOverride,
  defaultValue,
}) => (
  <select
    id={ `override-dd-${ rejection.key }` }
    className="form-select"
    value={ rejection.reason || defaultValue }
    disabled={ canOverride }
    onChange={ e => onOverrideReasonChange(e, rejection.code) }
  >
    {options.map(option => (
      <option key={ option.value } value={ option.value }>
        {option.label}
      </option>
    ))}
  </select>);

OverrideReasonDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  rejection: PropTypes.shape().isRequired,
  onOverrideReasonChange: PropTypes.func.isRequired,
  canOverride: PropTypes.bool.isRequired,
  defaultValue: PropTypes.string,
};

OverrideReasonDropdown.defaultProps = {
  defaultValue: null
};

export default OverrideReasonDropdown;
